import { Link } from "react-router-dom"; // If you still want to use react-router for other purposes

export default function Menu() {
    return (
        <>
            <ul className="navigation">
                <li>
                    <Link to="https://newranss.com.au" style={{fontSize: '22px'}}>Home</Link>
                </li>
                <li>
                    <Link to="https://services.newranss.com.au" style={{fontSize: '22px'}}>Services</Link>
                </li>
                <li>
                    <Link to="https://newranss.com.au/#about" style={{fontSize: '22px'}}>About</Link>
                </li>
                {/* <li>
                    <a href="#fundraise">Fundraise</a>
                </li>
                <li>
                    <a href="#chooseus">Choose Us</a>
                </li>
                <li>
                    <a href="#video1">Video</a>
                </li>
                <li>
                    <a href="#team">Team</a>
                </li>
                <li>
                    <a href="#testimonial">Testimonial</a>
                </li>
                <li>
                    <a href="#news">News</a>
                </li> */}
                <li>
                    <a href="https://newranss.com.au/#contact" style={{fontSize: '22px'}}>Contact</a>
                </li>
                  <li>
                    <a href="https://Referrals.newranss.com.au" style={{fontSize: '22px'}}>Referrals</a> {/* Scroll to Contact section */}
                </li>
            </ul>
        </>
    );
}
